import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithGmail_1 from '../../../../../libraries/Images/createAConnectionWithGmail_1.png';
import createAConnectionWithGmail_2 from '../../../../../libraries/Images/createAConnectionWithGmail_2.png';
import createAConnectionWithGmail_3 from '../../../../../libraries/Images/createAConnectionWithGmail_3.png';
import createAConnectionWithGmail_4 from '../../../../../libraries/Images/createAConnectionWithGmail_4.png';
import createAConnectionWithGmail_5 from '../../../../../libraries/Images/createAConnectionWithGmail_5.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithgmail">
                1.&nbsp;{translate('createaconnectionwithgmail')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "Gmail" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_2} width="75%" />
            </Zoom>
            <p>Khi bạn nhấp vào "Gmail", màn hình lựa chọn tài khoản Google của người dùng sẽ được hiển thị. Vui lòng chọn một tài khoản để sử dụng cho kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Khi bạn chọn một tài khoản, "RPA CLOUD" sẽ yêu cầu quyền truy cập thay cho bạn. Đồng ý cấp quyền truy cập trên cho "RPA CLOUD" và nhấp vào "Cho phép".</p>
            <Zoom>
                <img src={createAConnectionWithGmail_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ Gmail sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_5} width="50%"/>
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong Gmail.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);